(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_butterfly-mark"] && !Shopify.designMode) return;
  try {
    (() => {
    const WIDGET_SRC = 'https://plwidgetscript.stromdev.dk/widget.js';
    const TRIGGER_ID = 'pl-passport-widget-trigger-v1';
    const CONTAINER_ID = 'pl-passport-widget-trigger-v1-container';
    const IFRAME_ID = 'pl-passport-iframe-v1';
    const WIDGET_OPTIONS = {
      mode: 'widget',
      type: 'simple-badge',
      floating: false,
      colorScheme: 'white',
      align: 'left',
    };

    let initialised = false;
    let pendingLoad = null;

    function brandId() {
      const container = document.querySelector('[data-passport-brand]');
      return container ? container.dataset.passportBrand : '';
    }

    function vendorContainer() {
      return document.getElementById(TRIGGER_ID)?.querySelector('#' + CONTAINER_ID) ?? null;
    }

    function loadScript() {
      if (window.plPassportHelper) return Promise.resolve();
      if (pendingLoad) return pendingLoad;

      pendingLoad = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = WIDGET_SRC;
        script.addEventListener('load', () => resolve(), { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
      });

      return pendingLoad;
    }

    function initialiseWidget() {
      // The vendor's `init()` has no re-entrancy guard — a second call renders a second badge into
      // the same trigger. `pl-passport-widget-trigger-v1` is the vendor's own id, so only one badge
      // is supported per page regardless.
      if (initialised || !window.plPassportHelper) return;

      const brand = brandId();
      if (!brand) return;

      initialised = true;
      window.plPassportHelper.init({ ...WIDGET_OPTIONS, brandId: brand });
    }

    function showLoadingUntilIframeReady() {
      // An iframe already here means this click is a toggle, not a first open.
      if (document.getElementById(IFRAME_ID)) return;

      const loadingIndicator = document.querySelector('[loading-indicator]');
      const imageContainer = document.querySelector('[custom-image-container]');
      if (!loadingIndicator || !imageContainer) return;

      loadingIndicator.removeAttribute('hidden');
      imageContainer.setAttribute('butterfly-mark-loading', '');

      const hideIndicator = () => {
        loadingIndicator.setAttribute('hidden', '');
        imageContainer.removeAttribute('butterfly-mark-loading');
      };

      const observer = new MutationObserver(() => {
        const iframe = document.getElementById(IFRAME_ID);
        if (!iframe) return;
        observer.disconnect();
        iframe.addEventListener('load', hideIndicator, { once: true });
      });
      observer.observe(document.body, { childList: true });
    }

    // Nothing is fetched until someone actually asks for the passport. The vendor's badge is drawn
    // behind our own image and hidden, and its click handler only reads the brand id off the
    // container it creates — so init can wait for the click and then be handed that same click.
    const onTriggerClick = (event) => {
      showLoadingUntilIframeReady();

      // Vendor is already live; its own handler on the container takes this click.
      if (vendorContainer()) return;

      event.preventDefault();

      loadScript()
        .then(() => {
          initialiseWidget();
          vendorContainer()?.click();
        })
        .catch((error) => {
          console.error('Butterfly Mark: could not load the Positive Luxury widget.', error);
        });
    };

    function bindTrigger() {
      // This bundle runs on every page, so the trigger is often absent.
      const trigger = document.getElementById(TRIGGER_ID);
      if (!trigger) return;

      // Capture, so this runs before the vendor's handler on the container inside it.
      trigger.addEventListener('click', onTriggerClick, { capture: true });
    }

    bindTrigger();

    // The theme editor replaces the section's DOM, so the listener has to be rebound to the new
    // node. The event fires for every section though, not just this one — so only reset when the
    // trigger is actually empty, or editing an unrelated section stacks a second badge.
    document.addEventListener('shopify:section:load', () => {
      const trigger = document.getElementById(TRIGGER_ID);
      if (!trigger || trigger.children.length > 0) return;

      initialised = false;
      bindTrigger();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
